import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { EmployerBlockingCalendarResource } from 'util/resources/EmployerBlockingCalendar';
import { Base, Collection } from 'active-resource';

/**
 * Relationship classes
 */
export class EmployerThirdPartyCredentialAttributes {
  calendars: EmployerBlockingCalendarResource[];
  email: string;
  expiresAt: string;
  id: string;
  name: string;
  service: string;
}

export class EmployerThirdPartyCredentialBelongsTo {}
export class EmployerThirdPartyCredentialHasOne {}

export class EmployerThirdPartyCredentialHasMany {
  blockingCalendars: () => Collection<EmployerBlockingCalendarResource> = () =>
    new Collection<EmployerBlockingCalendarResource>();
}

/**
 * Utility interfaces
 */
export interface EmployerThirdPartyCredentialMethods {}

export interface EmployerThirdPartyCredentialInterface
  extends EmployerThirdPartyCredentialAttributes,
    EmployerThirdPartyCredentialBelongsTo,
    EmployerThirdPartyCredentialHasOne,
    EmployerThirdPartyCredentialHasMany,
    EmployerThirdPartyCredentialType {}

type EmployerThirdPartyCredentialType = GConstructor<EmployerThirdPartyCredentialInterface>;

export interface EmployerThirdPartyCredentialResource
  extends Base<EmployerThirdPartyCredentialAttributes>,
    EmployerThirdPartyCredentialInterface,
    EmployerThirdPartyCredentialMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<EmployerThirdPartyCredentialAttributes>({
    queryName: 'employers/third_party_credentials',
    className: 'ThirdPartyCredential',
    AttributesClass: EmployerThirdPartyCredentialAttributes,
    HasManyClasses: [
      {
        Klass: EmployerThirdPartyCredentialHasMany,
      },
    ],
  });

export const EmployerThirdPartyCredentialResourceClass = <
  TBase extends EmployerThirdPartyCredentialType,
>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements EmployerThirdPartyCredentialMethods {};

export class EmployerThirdPartyCredentialResource extends ClassExtender<EmployerThirdPartyCredentialInterface>(
  BaseClass,
  EmployerThirdPartyCredentialResourceClass,
) {}

/**
 * Resource instance
 */
export const EmployerThirdPartyCredential =
  APILibrary.createResource<EmployerThirdPartyCredentialResource>(
    EmployerThirdPartyCredentialResource,
  );
